import { defineMessage } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";

import { AlignToGoalsTabContent } from "./align-to-goals";
type TabId =
    | "align-to-goals"
    | "plan-and-track"
    | "harness-knowledge"
    | "ai-teammates";

type TWCTab = {
    id: TabId;
    title: {
        id: string;
        defaultMessage: string;
    };
    icon: string;
    iconGesture: string;
    tabComponent: React.ReactElement<typeof TabsContent>;
    englishLabel: string;
    heroImage: string;
    heroImageDimensions: {
        imageWidth: number;
        imageHeight: number;
    };
};
const TWC_TAB_DATA: TWCTab[] = [
    {
        id: "align-to-goals",
        title: defineMessage({
            id: "HomePageTemplate.twcHero.label.tab1",
            defaultMessage: "Align to goals"
        }),
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/bib125707t53vc4725oi23y27k840f25.svg",
        iconGesture:
            "https://dam-cdn.atl.orangelogic.com/AssetLink/dh5k7r067860c2lw755qk4225lnh064h.svg",
        tabComponent: <AlignToGoalsTabContent />,
        englishLabel: "Board of goals in customer portal",
        heroImage:
            "https://dam-cdn.atl.orangelogic.com/AssetLink/l3x685vh5v3848m7ahn64ck0w1tv4542.webp",
        heroImageDimensions: {
            imageWidth: 1152,
            imageHeight: 648
        }
    },
    {
        id: "plan-and-track",
        title: defineMessage({
            id: "HomePageTemplate.twcHero.label.tab1",
            defaultMessage: "Plan and track"
        }),
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/lem6xq7r2b8b3wj0sm8k007511hml00k.svg",
        iconGesture:
            "https://dam-cdn.atl.orangelogic.com/AssetLink/41ctiw00g13t41sx3kq52121f77kybmq.svg",
        tabComponent: <AlignToGoalsTabContent />,
        englishLabel: "Timeline in a marketing campaign",
        heroImage:
            "https://dam-cdn.atl.orangelogic.com/AssetLink/x77575w704j77xt8mibdp720ubo17pbk.webp",
        heroImageDimensions: {
            imageWidth: 1152,
            imageHeight: 648
        }
    },
    {
        id: "harness-knowledge",
        title: defineMessage({
            id: "HomePageTemplate.twcHero.label.tab1",
            defaultMessage: "Harness knowledge"
        }),
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/141bay62mq84i1s1cy46reh1mp0yr57p.svg",
        iconGesture:
            "https://dam-cdn.atl.orangelogic.com/AssetLink/5dmyh82cu21554ub13d26sx4scs5l625.svg",
        tabComponent: <AlignToGoalsTabContent />,
        englishLabel: "Confluence doc with an AI generated meeting summary",
        heroImage:
            "https://dam-cdn.atl.orangelogic.com/AssetLink/v6470jaq0j642skkx7ltj648lixci2so.webp",
        heroImageDimensions: {
            imageWidth: 1152,
            imageHeight: 648
        }
    },
    {
        id: "ai-teammates",
        title: defineMessage({
            id: "HomePageTemplate.twcHero.label.tab1",
            defaultMessage: "AI teammates"
        }),
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/4056w427ncf5oldsnmk04njn6c01h2t0.svg",
        iconGesture:
            "https://dam-cdn.atl.orangelogic.com/AssetLink/j6qh3wta803dmg5u3117478br61j7f3j.svg",
        tabComponent: <AlignToGoalsTabContent />,
        englishLabel:
            "Flow chart from a campaign brainstorm with an AI agent asking if it can help",
        heroImage:
            "https://dam-cdn.atl.orangelogic.com/AssetLink/75yxk8rcwh721mj26x2u4wskr8vgaf33.webp",
        heroImageDimensions: {
            imageWidth: 1152,
            imageHeight: 648
        }
    }
];

export { TWC_TAB_DATA, type TWCTab };
